module.exports = __webpack_public_path__ + "img/loading5.gif";